import rita from "rita";

function getRandomInt(min, max) {
  return min + Math.floor(Math.random() * (max - min));
}

export function generateTitle(inMobileMode) {
  // let rs = rita.randomWord("jj", 4);

  const w1 = capitalize(
    rita.randomWord({ pos: "jj", numSyllables: getRandomInt(1, 5) })
  );
  const w2 = capitalize(
    rita.randomWord({ pos: "jj", numSyllables: getRandomInt(1, 5) })
  );
  const w3 = capitalize(
    rita.randomWord({ pos: "nn", numSyllables: getRandomInt(1, 5) })
  );

  if (Math.random() > 0.4 || inMobileMode) return `${w1} ${w3}`;

  return `${w1} ${w2} ${w3}`;
}

function capitalize(s) {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
}

const starter =
  "#pluralVerb1# #adjective1# #noun1#, #verb1# #pluralNoun1# #preposition1# #adjective2# #pluralNoun2#, #adverb1# #verb2# #artTypeNoun1# #pluralNoun3#.";

export function generateDescription() {
  const starterElements = starter.split("#");
  let phrase = "";

  for (let el of starterElements) {
    phrase += getElement(el);
  }

  return phrase;
}

export function getNameForDescriptions(name) {
  const names = name.split(" ");
  const totalNames = names.length;
  let nameToUse = names[totalNames - 1];
  if (names.length > 1 && nameToUse.length < 1) {
    nameToUse = names[0];
  }

  return nameToUse;
}

const getElement = (el) => {
  let processedEl = el;

  if (grammar[el]) {
    const options = grammar[el];
    processedEl = options[Math.floor(Math.random() * options.length)];
  }

  return processedEl;
};

const grammar = {
  pluralVerb1: [
    "utilises",
    "employs",
    "promotes",
    "exploits",
    "applies",
    "manipulates",
    "flips",
    "reinvents",
    "adapts",
    "embraces",
    "exposes",
    "taps",
    "exposes",
    "deploys",
    "unfolds",
    "harnesses",
    "examines",
  ],
  adjective1: [
    "collective",
    "conceptual",
    "essential",
    "existential",
    "distinctive",
    "temporal",
    "synthetic",
    "primordial",
    "sublime",
    "provocative",
    "reductive",
    "fragile",
    "instinctive",
  ],
  noun1: [
    "non-being",
    "universalities",
    "unrealities",
    "violence",
    "passivities",
    "aggressions",
    "testaments",
    "robustnesses",
    "significance",
    "landscapes",
    "humanity",
  ],
  verb1: [
    "luring",
    "inviting",
    "enticing",
    "forcing",
    "hooking",
    "pulling",
    "ambushing",
    "tempting",
    "drawing",
    "inducing",
    "seducing",
    "pushing",
    "provoking",
    "challenging",
  ],
  pluralNoun1: [
    "viewers",
    "observers",
    "onlookers",
    "spectators",
    "gawkers",
    "witnesses",
    "bystanders",
    "beholders",
  ],
  preposition1: [
    "into",
    "toward",
    "inside",
    "within",
    "to leave",
    "to eschew",
    "to question",
    "to abandon",
    "to disregard",
    "to shun",
  ],
  adjective2: [
    "informal",
    "biological",
    "formal",
    "antiseptic",
    "aseptic",
    "sub-conscious",
    "consumerist",
    "transcendent",
    "uncreated",
    "subtle",
    "uncomfortable",
    "precarious",
    "multifaceted",
    "multi-layered",
    "mundane",
    "implicit",
    "explicit",
    "intense",
  ],
  pluralNoun2: [
    "unreality",
    "assemblages",
    "associations",
    "derivatives",
    "dialogues",
    "relationships",
    "transformations",
    "synthesis",
    "parallels",
    "confrontations",
    "narratives",
  ],
  adverb1: [
    "obliquely",
    "acutely",
    "systematically",
    "obtusely",
    "robustly",
    "unapologetically",
    "uncompromisingly",
  ],
  verb2: [
    "underpinning",
    "juxtaposing",
    "intensifying",
    "forging",
    "provoking",
    "pivoting",
    "deafening",
    "stifling",
    "engulfing",
    "devouring",
  ],
  artTypeNoun1: [
    "modernist",
    "impressionist",
    "cubist",
    "expressionist",
    "surrealist",
    "post-modernist",
    "deconstructionist",
    "gothic",
    "hyper-realist",
    "naive",
    "minimalist",
    "neoclassical",
    "neo-figurative",
    "primitive",
    "psychedelic",
    "purist",
    "symbolic",
    "sculptural",
  ],
  pluralNoun3: [
    "corruptions",
    "abstractions",
    "inevitability",
    "mundanity",
    "voids",
    "suggestion",
    "responses",
    "phenomena",
    "hesitations",
  ],
};
